<template>
  <div :class="classes" class="two-column-bg">
    <div class="template">
      <div class="column image">
        <div class="column-wipe"></div>
        <div class="column-bg"></div>
        <div class="image-column stagger-in" v-html="headerComputed"></div>
      </div>
      <div class="column content">
        <div class="column-wipe"></div>
        <div class="column-bg"></div>
        <div class="template-content">
          <div class="counter-component stagger-in">
            {{indexValue + 1}} - {{countValue}}
          </div>
          <h1 class="stagger-in" v-html="columnTwo.header"></h1>
          <p class="stagger-in" v-html="columnTwo.main"></p>
          <div class="supp stagger-in" v-html="columnTwo.supp"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { TimelineMax, Sine, TweenLite, Power2 } from 'gsap';
  import { gsapCustomEase, mobileLayout } from '../util';
  
  export default {
    name: 'TwoColumnBg',
    props: {
      columnOne: Object,
      columnTwo: Object,
      classes: Array,
      index: Number,
      count: Number,
      indexValue: Number,
      countValue: Number,
      finishTransition: Function
    },
    created() {
      if(this.columnOne.img){
        this.imageAsset = require('../assets/images/' + this.columnOne.header)
      }
      // this.suppAsset = require('../assets/images/' + this.supp)
    },
    computed: {
      headerComputed: function() {
        if(this.columnOne.img){
          return (
            `<img src="${this.imageAsset}"/>`
            )
        } else {
          return (
            `<h1>${this.columnOne.header}</h1>`
          )
        }
      }
    },
    methods: {
    	transitionIn: function (dir) {
        // console.log("TRANSITION FUNC TwoColumnBg");
        let $el = this.$el;
        let leftCol = $el.querySelector('.column.image');
        let rightCol = $el.querySelector('.column.content');

        let wipeLeft = leftCol.querySelector('.column-wipe');
        let wipeRight = rightCol.querySelector('.column-wipe');

        let transformOriginObjLeft = {'top':100};
        let transformOriginObjRight = {'top':0};

        // console.log(wipeLeft, wipeRight)
        let bgLeft = leftCol.querySelector('.column-bg');
        let bgRight = rightCol.querySelector('.column-bg');
        let staggerLeft = leftCol.querySelectorAll('.stagger-in');
        let staggerRight = rightCol.querySelectorAll('.stagger-in');

        let tl = new TimelineMax({onComplete: this.transitionInComplete})


        tl
        .set(bgLeft, {y: 100, opacity: 0})
        .set(bgRight, {y: -100, opacity: 0})
        .set(staggerLeft, {y: 160, opacity: 0})
        .set(staggerRight, {y: -160, opacity: 0})
        .set([wipeLeft, wipeRight], {scaleY: 0})
        .to([wipeLeft, wipeRight], 0.8, {scaleY: 0.96, ease:Sine.easeIn})
        .addLabel('wipe')
        .set([bgLeft, bgRight, staggerLeft, staggerRight], {opacity: 1})
        .to([bgLeft, bgRight], 0.3, {y: 0})
        .staggerTo(staggerLeft, 1.2, {y: 0, ease:Power2.easeOut}, 0.08, 'wipe-=0.24')
        .staggerTo(staggerRight, 1.2, {y: 0, ease:Power2.easeOut}, -0.08, 'wipe-=0.24')
        .to(transformOriginObjLeft, 0.24, {top:0, roundProps:'top', onUpdate:updateOriginLeft}, 'wipe')
        .to(transformOriginObjRight, 0.24, {top:100, roundProps:'top', onUpdate:updateOriginRight}, 'wipe')
        .to([wipeLeft, wipeRight], 0.4, {scaleY: 0, ease:Sine.easeOut}, 'wipe+=0.16')


        function updateOriginLeft() { TweenLite.set(wipeLeft, {transformOrigin: '50% ' + transformOriginObjLeft.top +  '%'}); }
        function updateOriginRight() { TweenLite.set(wipeRight, {transformOrigin: '50% ' + transformOriginObjRight.top +  '%'}); }

        let slides = document.querySelectorAll('.slide');
        tl.set(slides, {clearProps: 'opacity'}, 'wipe')

      },
      transitionOut: function () {
        let tl2 = new TimelineMax({onComplete: this.transitionOutComplete})

        tl2
        .set(this.$el, {opacity: 1})
      },
      transitionInComplete: function() {
        // console.log("ENABLE SITE INTERACTIONS")
        this.finishTransition();
      },
      transitionOutComplete: function() {
        // console.log("CLEAN UP SLIDE")
      }
    }
  } 
</script>

<style lang="scss">
@import '../sass/variables';

	.two-column-bg{
    .template{
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 100%;
      @include vw-units((
        'padding-top': 3
      ));
      @media #{$phoneQuery}{
        flex-direction: column; 
        justify-content: space-around;
        position: relative;
        min-height: 177.77vw;
      }
    }
    .column{
      width: 50%;
      padding: 0 7%;
      img{
        width: 100%;
      }
      @media #{$phoneQuery}{
        width: 100%;
        // padding-bottom: 10vw;
        &.content{
        }
        // height: 50%;
      }
      .column-bg{
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0;
        z-index: -1;
        @media #{$phoneQuery} { 
          width: 100%;
          height: 50%;
        }
      }
      .column-wipe{
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0;
        z-index: 3;
        background: rgba(255,255,255,1);
        @media #{$phoneQuery} { 
          width: 100%;
          height: 50%;
        }
      }
      &.image{
        .column-bg{
          left: 0;
          @media #{$phoneQuery} { top: 0; }
          background: $orange;
        }
        .column-wipe{ 
          left: 0; 
          transform-origin: 50% 100%;
        }
      }
      &.content{
        .column-bg{
          right: 0;
          @media #{$phoneQuery} { 
            top: 50%;
          }
          background: $lightpurple;
        }
        .column-wipe{ 
          right: 0; 
          transform-origin: 50% 0%;
          @media #{$phoneQuery}{
            top: 50%;
          }
        }
      }
    }
    .image-column{
      width: 80%;
      margin: 0 auto;
      h1{
        color: #fff;
        text-align: center;
        line-height: 1.2;
        @include vw-pixels((
          'font-size': 50
        ), 1.5);
      }
    }
    .template-content{
      h1{
        color: #fff;
        line-height: 1.1;
        @include vw-pixels((
          'font-size': 48,
          'margin-bottom': 8
        ), 1.5);
      }
      p{
        color: #fff;
        font-family: freight-text-pro, serif;
        letter-spacing: 0.01em;
        line-height: 1.3;
        span{
          color: #fff;
        }
        @include vw-pixels((
          'margin-left': 32,
          'font-size': 22
        ), 2);
        @media #{$phoneQuery}{
          margin-left: 0;
          // font-size: 3.2vw;
        }
      }
      .supp{
        @include vw-units((
          'width': 18
        ));
        margin-left: 10%;
        margin-top: 4%;
        @media #{$phoneQuery}{
          margin-left: 0;
          width: 56vw;
        }
        a{
          color: inherit;
          text-decoration: none;
        }
      }
    }
    .counter-component{
      color: #fff;
      &:after{
        background: $blue;
      }
    }
    .report-btn{
      border: 1px solid $blue;
      border-radius: 2em;
      padding: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      span{
        color: $blue;
        line-height: 1;
        white-space: nowrap;
        font-weight: 500;
        letter-spacing: 0;
        @include vw-pixels((
          'font-size': 18
        ));
      }
    }
    &.sound-1{
      @media #{$phoneQuery}{
        .column.content .column-bg{
          height: 62%;
          top: 38%;
        }   
      }
      .template-content{
        .supp{
          @include vw-units((
            'width': 12
          ));
        }
      }
    }
	}
</style>